
// Dependencies
import 'babel-polyfill';
import 'whatwg-fetch';
import '../styles/app.css';
import formMessage from './utility/form-message';

// Components
import Stage from './components/stage';
import NavSearch from './components/nav-search';
import NavBar from './components/nav-bar';
import Form from './components/form';

// Constants
const stage = document.querySelectorAll('.stage')[0] ? new Stage(document.querySelectorAll('.stage')[0]) : null;
const navSearch = new NavSearch(document.getElementById('nav-search-toggle'));
const navBar = new NavBar(
  document.getElementById('offcanvas-wrap'),
  document.getElementsByTagName('NAV')[0],
  document.getElementById('offcanvas-toggle'),
  document.getElementById('offcanvas-dismiss')
);
const footerContactForm = new Form(
  document.getElementById('footer-newsletter-form'),
  submitFooterContactForm
);

window.addEventListener('resize', setContentAreaMinHeight);

document.addEventListener('DOMContentLoaded', () => {
  if (stage) stage.init();

  navSearch.init();

  navBar.init();

  footerContactForm.init();

  setContentAreaMinHeight();
});

function submitFooterContactForm(form, formData) {
  const { method } = form;

  fetch('/', {
    method,
    body: formData.dataString,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
    .then(result => {
      formMessage(form, 'Thanks for contacting us!')
    })
    .catch(error => {
      formMessage(form, 'An error occurred. Please go back and try again.')
    });
}

function setContentAreaMinHeight() {
  const header = document.querySelector('header');
  const footer = document.querySelector('footer');
  const main = document.querySelector('main');
  const minHeight = `${window.innerHeight - header.clientHeight - footer.clientHeight}px`;

  if (main.style.minHeight !== minHeight) main.style.minHeight = minHeight;
}



// WEBPACK FOOTER //
// ./app.js